import usePointOfSale from "../../../hooks/usePointOfSale.js";
export const flexDatesRestrictedCountries = ["id", "qa", "ph"];
export const useFlexDatesRectrictedPOS = () => {
    const pos = usePointOfSale();
    return flexDatesRestrictedCountries.some((c) => pos === c);
};
